import React from 'react';
import { ROLE, RouteObject } from '../types/routeObject';
import { NotFound } from '../pages/NotFound';

export default function AdminRoute(props: RouteObject) {
  return {
    path: props.path,
    handle: props.handle,
    element: props.role == ROLE.ADMIN ? props.component : <NotFound />,
  };
}
